"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _objectDestructuringEmpty2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/objectDestructuringEmpty.js"));
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _mutations;
var _default = {
  namespaced: true,
  state: {
    dataInfo: {
      limit: 24
    },
    groupInfo: {
      id: -1,
      name: '全部'
    },
    groupList: [],
    photoList: [],
    pageInfo: {
      size: 15,
      total: 0,
      current: 1
    }
  },
  mutations: (_mutations = {
    /**
     * 设置数据
     * @param {[type]} state [description]
     * @param {[type]} data  [description]
     */
    setGroupInfo: function setGroupInfo(state, data) {
      state.dataInfo = data;
    }
  }, (0, _defineProperty2.default)(_mutations, "setGroupInfo", function setGroupInfo(state, data) {
    state.groupInfo = data;
  }), (0, _defineProperty2.default)(_mutations, "setGroupList", function setGroupList(state, data) {
    state.groupList = data;
  }), (0, _defineProperty2.default)(_mutations, "setPageInfo", function setPageInfo(state, data) {
    state.pageInfo = data;
  }), (0, _defineProperty2.default)(_mutations, "setPhotoList", function setPhotoList(state, data) {
    state.photoList = data;
  }), _mutations),
  actions: {
    upadteGroupInfo: function upadteGroupInfo(_ref, value) {
      var commit = _ref.commit;
      commit('setGroupInfo', value);
    },
    /**
     * 获取分类数据
     * @param  {[type]} options.commit   [description]
     * @param  {[type]} options.userName [description]
     * @param  {[type]} options.password [description]
     * @return {[type]}                  [description]
     */
    LoadGroupList: function LoadGroupList(_ref2) {
      var commit = _ref2.commit;
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var VM = this._vm;
      var $heshop = this._vm.$heshop;
      return new Promise(function (resolve, reject) {
        $heshop.group('get', {
          include: 'gallery',
          parent_id: id,
          type: 1
        }).then(function (data) {
          commit('setGroupList', data);
          resolve(data);
        }).catch(function (error) {
          VM.$message({
            type: 'error',
            message: '网络请求错误，请刷新'
          });
          reject(error);
        });
      });
    },
    /**
     * 创建分类数据
     * @param  {[type]} options.commit   [description]
     * @param  {[type]} options.userName [description]
     * @param  {[type]} options.password [description]
     * @return {[type]}                  [description]
     */
    InterGroupItem: function InterGroupItem(_ref3, _ref4) {
      (0, _objectDestructuringEmpty2.default)(_ref3);
      var name = _ref4.name,
        id = _ref4.id;
      var VM = this._vm;
      var $heshop = this._vm.$heshop;
      return new Promise(function (resolve, reject) {
        $heshop.group('post', {
          include: 'gallery'
        }, {
          name: name,
          type: 1,
          parent_id: id || 0,
          sort: 5
        }).then(function (data) {
          VM.$message({
            type: 'success',
            message: '添加成功'
          });
          resolve(data);
        }).catch(function (error) {
          if (error.data.message) {
            VM.$message({
              type: 'error',
              message: error.data.message
            });
          } else {
            VM.$message({
              type: 'error',
              message: '创建失败'
            });
          }
          reject(error);
        });
      });
    },
    /**
     * 删除分组
     * @param  {[type]} options.commit   [description]
     * @param  {[type]} options.userName [description]
     * @param  {[type]} options.password [description]
     * @return {[type]}                  [description]
     */
    DeleteGroupItem: function DeleteGroupItem(_ref5, _ref6) {
      (0, _objectDestructuringEmpty2.default)(_ref5);
      var id = _ref6.id;
      var VM = this._vm;
      var $heshop = this._vm.$heshop;
      return new Promise(function (resolve, reject) {
        $heshop.group('delete', id, {
          include: 'gallery'
        }).then(function (data) {
          VM.$message({
            type: 'success',
            message: '删除成功'
          });
          resolve(data);
        }).catch(function (error) {
          VM.$message({
            type: 'error',
            message: '此分组下有文件夹，不支持删除'
          });
          reject(error);
        });
      });
    },
    /**
     * 编辑分类数据
     * @param  {[type]} options.commit   [description]
     * @param  {[type]} options.userName [description]
     * @param  {[type]} options.password [description]
     * @return {[type]}                  [description]
     */
    UpdateGroupItem: function UpdateGroupItem(_ref7, value) {
      (0, _objectDestructuringEmpty2.default)(_ref7);
      var VM = this._vm;
      var $heshop = this._vm.$heshop;
      return new Promise(function (resolve, reject) {
        $heshop.group('put', {
          include: 'gallery',
          id: parseInt(value.id)
        }, {
          name: value.name
        }).then(function (data) {
          VM.$message({
            type: 'success',
            message: '命名成功'
          });
          resolve(data);
        }).catch(function (error) {
          VM.$message({
            type: 'error',
            message: '修改失败'
          });
          reject(error);
        });
      });
    },
    /**
     * 获取照片信息
     * @param  {[type]} options.state  [description]
     * @param  {[type]} options.commit [description]
     * @return {[type]}                [description]
     */
    LoadPhotoList: function LoadPhotoList(_ref8, _ref9) {
      var commit = _ref8.commit;
      var id = _ref9.id,
        current = _ref9.current,
        pageSize = _ref9.pageSize;
      var VM = this._vm;
      var $heshop = this._vm.$heshop;
      var $pageSize = pageSize || 24;
      var $id = id || 0;
      return new Promise(function (resolve, reject) {
        $heshop.gallery('get', {
          group_id: parseInt($id)
        }).page(current, $pageSize).then(function (data) {
          var size = parseInt(data.headers['x-pagination-per-page']);
          var total = parseInt(data.headers['x-pagination-total-count']);
          var current = parseInt(data.headers['x-pagination-current-page']);
          commit('setPageInfo', {
            size: size,
            total: total,
            current: current
          });
          commit('setPhotoList', data.data);
          resolve(data.data);
        }).catch(function (error) {
          VM.$message({
            type: 'error',
            message: '网络请求错误，请刷新'
          });
          reject(error);
        });
      });
    },
    /**
     * 删除图片
     * @param  {[type]} options.state  [description]
     * @param  {[type]} options.commit [description]
     * @param  {[type]} data           [description]
     * @return {[type]}                [description]
     */
    DeletePhotoList: function DeletePhotoList(_ref10, value) {
      (0, _objectDestructuringEmpty2.default)(_ref10);
      var VM = this._vm;
      var $heshop = this._vm.$heshop;
      return new Promise(function (resolve, reject) {
        $heshop.gallery('delete', value).then(function (data) {
          VM.$message({
            type: 'success',
            message: '删除成功'
          });
          resolve(data);
        }).catch(function (error) {
          VM.$message({
            type: 'error',
            message: '删除失败'
          });
          reject(error);
        });
      });
    },
    /**
     * 获取所欲分类
     * @param  {[type]} options.commit   [description]
     * @param  {[type]} options.userName [description]
     * @param  {[type]} options.password [description]
     * @return {[type]}                  [description]
     */
    MovePhotoList: function MovePhotoList(_ref11, _ref12) {
      (0, _objectDestructuringEmpty2.default)(_ref11);
      var list = _ref12.list,
        group_id = _ref12.group_id;
      var VM = this._vm;
      var $heshop = this._vm.$heshop;
      return new Promise(function (resolve, reject) {
        $heshop.gallery('put', {
          behavior: 'setgroup',
          id: list
        }, {
          group_id: group_id
        }).then(function (data) {
          VM.$message({
            type: 'success',
            message: '移动成功'
          });
          resolve(data);
        }).catch(function (error) {
          VM.$message({
            type: 'error',
            message: '移动失败'
          });
          reject(error);
        });
      });
    },
    /**
     * 编辑照片信息
     * @param  {[type]} options.state  [description]
     * @param  {[type]} options.commit [description]
     * @return {[type]}                [description]
     */
    UpdatePhotoItem: function UpdatePhotoItem(_ref13, value) {
      (0, _objectDestructuringEmpty2.default)(_ref13);
      var VM = this._vm;
      var $heshop = this._vm.$heshop;
      return new Promise(function (resolve, reject) {
        $heshop.gallery('put', parseInt(value.id), {
          title: value.name
        }).then(function (data) {
          VM.$message({
            type: 'success',
            message: '命名成功'
          });
          resolve(data);
        }).catch(function (error) {
          VM.$message({
            type: 'error',
            message: '命名失败，文件夹以存在'
          });
          reject(error);
        });
      });
    }
  }
};
exports.default = _default;